import styled from "styled-components";

const DeclerationWrapper = styled.div`
.Dec-det {
  margin: 20px 0;padding: 22px;background: #F2F3F5;border-bottom: 2px solid #F2F3F5;border-radius: 8px;
}
.Heading-dec {

font-weight: 800;font-size: 1.25rem;color: #4C565C;
}
.Subheading{font-weight: 400;font-size: 1rem;color: #4C565C;margin:0;}
.visa-hr {
  margin-bottom: 0 !important;
}
.Dec-Input {
  .p-inputtext {
    border: none;
    width: 100%;
    font-weight: 700;
    background: #ffffff;
    box-shadow: 0px 4px 10px rgba(9, 30, 66, 0.06);
    border-radius: 4px;
    font-size: 1rem;
    color: #4c565c;
    padding: 1.3rem 0.75rem 0.4rem 0.75rem;
  }
  .p-float-label input:focus ~ label,
  .p-float-label input.p-filled ~ label {
    // top: 0.75rem;
    // font-size: 0.7rem;
    top: 1rem;
    font-size: 0.7rem;
  }
}
.Dec-Input{
	label{
		right:12px;
	}
}
.p-float-label input.p-filled ~ label {
  top: 1rem;
  font-size: 0.7rem;
}

.p-radiobutton .p-radiobutton-box.p-highlight{
  border-color: ${props => `${props.businessColor} !important`};
  background: ${props => `${props.businessColor} !important`};
}
.p-radiobutton .p-radiobutton-box:not(.p-disabled):not(.p-highlight):hover {
  border-color: ${props => props.businessColor};
}

@media screen and (max-width: 767px) {
  .d-flex {
    display: block !important;
  }
  .field-radiobutton{
    display: flex;
    margin-bottom: 10px;
  }

}
.p-dropdown {
	width: 100%;
	border-radius: 4px;
	border: none;
	font-weight: 700;
	font-size: 1rem;
	color: #4c565c;
	box-shadow: 0px 4px 10px rgb(9 30 66 / 6%);
	height: 51px;
  }
  .exp-date {
    z-index: 999999;
    position: relative;
    top: -48px;
    margin-inline-start: 59px;
    font-size: 12px;
    font-weight: 700;
  }
  .p-float-label .p-inputwrapper-focus ~ label,
  .p-float-label .p-inputwrapper-filled ~ label {
	top: 0.9rem !important;
	font-size: 0.7rem !important;
	color: #676f7c !important;
	right: 12px !important;
  }
  .p-button:focus {
	box-shadow: none;
  }
}
.set-accord {
  // background: #F2F3F5;
border-radius: 10px;
padding: 0px;
display: flex;
flex-direction: column;
text-align: initial;
margin-top: 50px;
// border-radius: 8px !important;
}
.p-accordion-toggle-icon.pi {
  display: none;
}
.p-accordion-tab{
      margin-bottom: 0px !important;
      background: none !important;
}
.down-acc 
// color: #6B47F5 !important;
}

.p-accordion .p-accordion-content {
  padding: 0 24px 24px !important;
  border-radius: 0px 0px 12px 12px !important;
  background: #F2F3F5;
  // border-radius: 8px !important;
  .p-disabled, .p-component:disabled {
    opacity: 0.6;
  }
}
.p-accordion
  .p-accordion-header:not(.p-disabled).p-highlight
  .p-accordion-header-link {
  border-radius: 12px 12px 0px 0px !important;
  background: #F2F3F5 !important;
  // border-radius: 8px !important;
  border-color: transparent !important;

}
.p-accordion .p-accordion-header .p-accordion-header-link {
  border-radius: 12px !important;
  display: block !important;
  padding: 32px 12px 32px 24px !important;
  background: #F2F3F5 !important;
  border-radius: 8px !important;
  border-color: transparent !important;
}
.header-flex {
  display: flex;
  align-items: center;
}


.Heading-other {

font-weight: 800;font-size: 1.25rem;color: #4C565C;
}
.Subheading-oth{font-weight: 400;font-size: 1rem;color: #4C565C;margin:0;}

.Dec-Input {
  .p-inputtext {
    border: none;
    width: 100%;
    font-weight: 700;
    // background: #ffffff;
    box-shadow: 0px 4px 10px rgba(9, 30, 66, 0.06);
    border-radius: 4px;
    font-size: 1rem;
    color: #4c565c;
	padding: 1.3rem 0.75rem 0.4rem 0.75rem;
  }
  .p-float-label input:focus ~ label,
  .p-float-label input.p-filled ~ label {
    top: 0.75rem;
    font-size: 0.7rem;
  }
}
.Dec-Input{
	label{
		right:12px;
	}
}
.SerialID {
	.p-inputtext {
    border: none;
    width: 100%;
    font-weight: 700;
    // background: #ffffff;
    // box-shadow: 0px 4px 10px rgba(9, 30, 66, 0.06);
    border-radius: 4px;
    font-size: 1rem;
    color: #4c565c;
	top:4px;
	position: relative;
	padding: 1rem 0.75rem 0.4rem 0.75rem;
  }
		i.pi.pi-credit-card {
		  position: absolute;
		  margin: 17px 20px;
		  font-size: 1.3rem;
		  color: #6B47F5;
		}
		i.pi.pi-camera {
		  position: absolute;
		  margin: 17px -40px;
		  color: #1f1f1f;
		  font-size: 1.3rem;
		}
		.p-float-label label {
		  // left: 70px;
		}
		.p-float-label input:focus ~ label,
		.p-float-label input.p-filled ~ label {
		  top: 0.75rem;
		  font-size: 0.7rem;
		}
		.national-id {
		  position: absolute;
		  top: 15px;
		  left: 16px;
		}
	  }
	  .p-inputtext {
		font-size: 0.9rem;
	  }
    .calender {
		.p-calendar {
		  width: 100%;
		}
		.p-inputtext {
		  background: #ffffff;
		  box-shadow: 0px 4px 10px rgb(9 30 66 / 6%);
		  border-radius: 4px;
		  border: none;
		  // padding: 20px 10px 10px;
		  height: 51px;
		  font-weight: 700;
		  font-size: 1rem;
		  color: #4c565c;
		  padding: 1.3rem 0.75rem 0.4rem 0.75rem;
		}
		.p-button {
		  background: #f2f3f5;
		  border: none;
		  box-shadow: 0px 4px 10px rgb(9 30 66 / 6%);
		}
		.p-float-label .label-en{
			left 55px;
		}
		.p-float-label .cal-lbel{
			left: 60px;
		}
		.p-float-label .cal-lbel.ar{
			right: 60px;
		}
		.p-float-label .label-ar{
			right: 54px;
		}
		.p-float-label .p-inputwrapper-focus ~ label,
		.p-float-label .p-inputwrapper-filled ~ label {
		  top: 0.8rem !important;
		  font-size: 0.7rem !important;
		  color: #676f7c !important;
		  left: 3.8rem !important;
		}
		.p-button:focus {
		  box-shadow: none;
		}	
		.dec-lbl {
			.p-inputtext {
				padding: 0.75rem !important;
			}
			.p-float-label label
			{
				top: 50% !important;
			}
		}
	}
	.SerialID {
		label {
			right: 12px !important;
		}
	}
	.ar{
		.fm-tawuniya{
			font-family: "tawuniya" !important;
		}
	}
    .lable-dist{
      top: 14px!important;
    }
    .margin-bott{
      marginBottom: "-15px"
	}


	.Heading-dec {
		font-weight: 800;
		font-size: 1.25rem;
		color: #4C565C;
	}

	.p-radiobutton .p-radiobutton-box.p-highlight{
		border-color: ${props => `${props.businessColor} !important`};
		background: ${props => `${props.businessColor} !important`};
	}
	.p-radiobutton .p-radiobutton-box:not(.p-disabled):not(.p-highlight):hover {
		border-color: ${props => props.businessColor};
	}
`;

export default DeclerationWrapper;
